// extracted by mini-css-extract-plugin
export default {"tasks":"TasksFilter_tasks__c8wVL","empty":"TasksFilter_empty__TJB9H","tasksGrid":"TasksFilter_tasksGrid__BMizR"};